// extracted by mini-css-extract-plugin
module.exports = {"feature-promo-wrapper":"FeaturePromo__feature-promo-wrapper___22I3L"};